export const CUSTOMERS_ENDPOINT = '/customers';

export const CustomersCacheKeys = Object.freeze({
  GetCustomer: 'getCustomer',
  GetCustomerFullName: 'getCustomerFullName',
  GetCustomerProfile: 'getCustomerProfile',
  GetCustomerDashboard: 'getCustomerDashboard',
});
